import topButtonIcon from "../assets/img/Desktop/Meteor_component_5_D.png";
const ToTopButton = () => {
  return (
    <button
      className="fixed md:translate-x-2/4 bottom-5% right-5% "
      onClick={() => {
        window.scrollTo({
          top: 0,
          behavior: "smooth",
        });
      }}
    >
      <img src={topButtonIcon} alt="最上面按鈕" className="w-60px" />
    </button>
  );
};
export default ToTopButton;
